// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-page-layout {
  display: flex;
  justify-content: center;
  width: 100vw;
  padding: 5rem;
  box-sizing: border-box;
  background: white;
  gap: 5vw;
}

.signup-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background: #f7f7f7;
  min-width: 40vw;
}

.signup-right-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 40vw;
}

.signup-logo {
  width: 100%;
  max-width: 500px;
  height: auto;
  margin-bottom: 2rem;
}

.signup-title {
  margin-bottom: 20px;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  font-style: italic;
  text-align: center;
}

.form-group-form-control {
  position: relative;
  margin: 20px 0;
  width: 100%;
}

.form-input {
  background-color: transparent;
  border: 0;
  border-bottom: 2px solid #ddd;
  display: block;
  width: 100%;
  font-size: 1.5rem;
  color: #000;
  box-sizing: border-box;
}

.form-input:focus,
.form-input:valid {
  outline: 0;
  border-bottom-color: lightblue;
}

.signup-page-layout .form-label {
  position: absolute;
  top: 0rem; /* Initial Form-Label Position*/
  left: 3rem;
  pointer-events: none;
  transition: all 0.3s ease;
  color: #aaa;
}

.form-icons {
  transform: scale(1.15);
}

.form-group-form-control span {
  display: inline-block;
  font-size: 1.5rem;
  min-width: 5px;
  transition: 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.signup-page-layout .form-input:focus + .form-label,
.signup-page-layout .form-input:valid + .form-label {
  color: lightblue;
}

.signup-page-layout .form-input:focus + .form-label span,
.signup-page-layout .form-input:valid + .form-label span {
  transform: translateY(-42px); /* Rise or Lower Position*/
}

.signup-page-layout .input-invalid {
  border-bottom: 2px solid #ff6b6b;
}

.error-message {
  color: #ff6b6b;
  margin-top: 0.25rem;
  font-size: 1rem;
  text-align: left;
}

.btn-register {
  display: inline-block;
  padding: 12px 24px;
  border: 1px solid #4f4f4f;
  border-radius: 10px;
  transition: all 0.2s ease-in;
  position: relative;
  overflow: hidden;
  font-size: 19px;
  color: black;
  z-index: 1;
}

.btn-register:before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%) scaleY(1) scaleX(1.25);
  top: 100%;
  width: 140%;
  height: 180%;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  display: block;
  transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
  z-index: -1;
}

.btn-register:after {
  content: "";
  position: absolute;
  left: 55%;
  transform: translateX(-50%) scaleY(1) scaleX(1.45);
  top: 180%;
  width: 160%;
  height: 190%;
  background-color: #39bda7;
  border-radius: 50%;
  display: block;
  transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
  z-index: -1;
  margin-top: 1rem;
}

.btn-register:hover {
  color: #ffffff;
  border: 1px solid #39bda7;
}

.btn-register:hover:before {
  top: -35%;
  background-color: #39bda7;
  transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}

.btn-register:hover:after {
  top: -45%;
  background-color: #39bda7;
  transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
}

.login-link-redirect {
  color: #007bff;
  cursor: pointer;
  text-align: center;
}

.login-link-redirect:hover {
  text-decoration: underline;
}

@media (max-width: 991px) {
  .signup-page-layout {
    margin-top: 10rem;
    flex-direction: column;
    width: 80vw;
    padding: 1rem;
    margin-left: 15vw;
    margin-right: 15vw;
  }

  .signup-form,
  .signup-right-column {
    width: 100%;
    align-items: center;
    padding: 0;
  }

  .signup-title {
    font-size: 4.5rem;
  }

  .form-icons {
    transform: scale(2.5);
  }

  .form-group-form-control span {
    font-size: 3rem;
    font-weight: 700;
  }

  .signup-page-layout .form-label {
    position: absolute;
    top: 0rem; /* Initial Form-Label Position*/
    left: 4rem;
  }

  .signup-page-layout .form-input:focus + .form-label span,
  .signup-page-layout .form-input:valid + .form-label span {
    transform: translateY(-45px); /* Rise or Lower Position*/
  }

  .signup-page-layout .form-label,
  .signup-page-layout .form-input {
    font-size: 3rem;
  }

  .error-message {
    font-size: 2.5rem;
  }

  .btn-register {
    font-size: 3.25rem;
  }

  .signup-logo {
    width: 70vw;
  }

  .login-link-redirect {
    margin-top: 1rem;
    width: -moz-max-content;
    width: max-content;
    font-size: 2.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/CreateAccount.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,+BAA+B;EAC1C,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,uDAAuD;AACzD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kDAAkD;EAClD,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kDAAkD;EAClD,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,uDAAuD;EACvD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS,EAAE,+BAA+B;IAC1C,UAAU;EACZ;;EAEA;;IAEE,4BAA4B,EAAE,0BAA0B;EAC1D;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":[".signup-page-layout {\n  display: flex;\n  justify-content: center;\n  width: 100vw;\n  padding: 5rem;\n  box-sizing: border-box;\n  background: white;\n  gap: 5vw;\n}\n\n.signup-form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  background: #f7f7f7;\n  min-width: 40vw;\n}\n\n.signup-right-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 40vw;\n}\n\n.signup-logo {\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  margin-bottom: 2rem;\n}\n\n.signup-title {\n  margin-bottom: 20px;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  font-style: italic;\n  text-align: center;\n}\n\n.form-group-form-control {\n  position: relative;\n  margin: 20px 0;\n  width: 100%;\n}\n\n.form-input {\n  background-color: transparent;\n  border: 0;\n  border-bottom: 2px solid #ddd;\n  display: block;\n  width: 100%;\n  font-size: 1.5rem;\n  color: #000;\n  box-sizing: border-box;\n}\n\n.form-input:focus,\n.form-input:valid {\n  outline: 0;\n  border-bottom-color: lightblue;\n}\n\n.signup-page-layout .form-label {\n  position: absolute;\n  top: 0rem; /* Initial Form-Label Position*/\n  left: 3rem;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  color: #aaa;\n}\n\n.form-icons {\n  transform: scale(1.15);\n}\n\n.form-group-form-control span {\n  display: inline-block;\n  font-size: 1.5rem;\n  min-width: 5px;\n  transition: 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.signup-page-layout .form-input:focus + .form-label,\n.signup-page-layout .form-input:valid + .form-label {\n  color: lightblue;\n}\n\n.signup-page-layout .form-input:focus + .form-label span,\n.signup-page-layout .form-input:valid + .form-label span {\n  transform: translateY(-42px); /* Rise or Lower Position*/\n}\n\n.signup-page-layout .input-invalid {\n  border-bottom: 2px solid #ff6b6b;\n}\n\n.error-message {\n  color: #ff6b6b;\n  margin-top: 0.25rem;\n  font-size: 1rem;\n  text-align: left;\n}\n\n.btn-register {\n  display: inline-block;\n  padding: 12px 24px;\n  border: 1px solid #4f4f4f;\n  border-radius: 10px;\n  transition: all 0.2s ease-in;\n  position: relative;\n  overflow: hidden;\n  font-size: 19px;\n  color: black;\n  z-index: 1;\n}\n\n.btn-register:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%) scaleY(1) scaleX(1.25);\n  top: 100%;\n  width: 140%;\n  height: 180%;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 50%;\n  display: block;\n  transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);\n  z-index: -1;\n}\n\n.btn-register:after {\n  content: \"\";\n  position: absolute;\n  left: 55%;\n  transform: translateX(-50%) scaleY(1) scaleX(1.45);\n  top: 180%;\n  width: 160%;\n  height: 190%;\n  background-color: #39bda7;\n  border-radius: 50%;\n  display: block;\n  transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);\n  z-index: -1;\n  margin-top: 1rem;\n}\n\n.btn-register:hover {\n  color: #ffffff;\n  border: 1px solid #39bda7;\n}\n\n.btn-register:hover:before {\n  top: -35%;\n  background-color: #39bda7;\n  transform: translateX(-50%) scaleY(1.3) scaleX(0.8);\n}\n\n.btn-register:hover:after {\n  top: -45%;\n  background-color: #39bda7;\n  transform: translateX(-50%) scaleY(1.3) scaleX(0.8);\n}\n\n.login-link-redirect {\n  color: #007bff;\n  cursor: pointer;\n  text-align: center;\n}\n\n.login-link-redirect:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 991px) {\n  .signup-page-layout {\n    margin-top: 10rem;\n    flex-direction: column;\n    width: 80vw;\n    padding: 1rem;\n    margin-left: 15vw;\n    margin-right: 15vw;\n  }\n\n  .signup-form,\n  .signup-right-column {\n    width: 100%;\n    align-items: center;\n    padding: 0;\n  }\n\n  .signup-title {\n    font-size: 4.5rem;\n  }\n\n  .form-icons {\n    transform: scale(2.5);\n  }\n\n  .form-group-form-control span {\n    font-size: 3rem;\n    font-weight: 700;\n  }\n\n  .signup-page-layout .form-label {\n    position: absolute;\n    top: 0rem; /* Initial Form-Label Position*/\n    left: 4rem;\n  }\n\n  .signup-page-layout .form-input:focus + .form-label span,\n  .signup-page-layout .form-input:valid + .form-label span {\n    transform: translateY(-45px); /* Rise or Lower Position*/\n  }\n\n  .signup-page-layout .form-label,\n  .signup-page-layout .form-input {\n    font-size: 3rem;\n  }\n\n  .error-message {\n    font-size: 2.5rem;\n  }\n\n  .btn-register {\n    font-size: 3.25rem;\n  }\n\n  .signup-logo {\n    width: 70vw;\n  }\n\n  .login-link-redirect {\n    margin-top: 1rem;\n    width: max-content;\n    font-size: 2.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
